<template>
  <div id="premiumconfirmation">
    <v-layout row wrap style="padding: 15px;">
      <v-flex xs1>
        <v-btn small icon dark @click="close()">
          <v-icon color="#10aa85">arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs10 style="padding-top:6px;">
        <span style="color:#10aa85;font-size:18px;">{{$route.params.feature}}</span>
      </v-flex>
    </v-layout>
    <v-container text-xs-center class="pt-5">
      <v-layout row wrap>
        <v-flex xs12>
          <img src="@/assets/comingsoon.png" alt="svg-comingsoon">
        </v-flex>
        <v-flex xs12>
          <p>
            <span style="color:#10aa85; font-size:18px;font-weight:bold;">
            Segera Hadir
          </span>
          </p>

        </v-flex>
        <v-flex xs12>
          <p>
            Sabar ya! Fiturnya belum tersedia di <b>app.nfjuara.id</b> nih. Kamu bisa mengaksesnya melalui aplikasi NFJUARA
          </p>
          <img src="@/assets/btn_playstore.svg" alt="googleplay" @click="toGPlay()">
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

/* eslint-disable */
export default {
  name: 'coming-soon',
  data() {
    return{
      show: true
    }
  },
  methods: {
    close() {
      this.$router.push('/')
    },
    toGPlay(){
      window.open('https://play.google.com/store/apps/details?id=id.co.nurulfikri.nfjuara')
    }
  }
}
</script>
